import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MediaItem } from 'src/app/Models/Classes/Media/media-item';
import { PublicationClass } from 'src/app/Models/Classes/Publications/publication-class';
import { MultimediaViewComponent } from '../multimedia-view/multimedia-view.component';
import { isVideo,isImage } from 'src/app/utils';
import {Capacitor} from "@capacitor/core";
import { App } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';
import { LkfilmViewBySlidesComponent } from './../../../lkfilm-view-by-slides/lkfilm-view-by-slides.component';
import Swiper from 'swiper';
import { IonSlides } from '@ionic/angular';
import  Swal from 'sweetalert2';
import { ActualizacionServiceService } from 'src/app/services/actualizacion/Actualizacion-service.service';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import {PublicationMediaTemplateComponent} from 'src/app/components/publication/publication-media-template/publication-media-template.component';
import { NativeLiquidGlass } from 'src/app/plugins/native-runtime.plugins';
import { RequestService } from 'src/app/services/request/request.service';

type WebKitPictureInPictureVideo = HTMLVideoElement & {
  webkitPresentationMode?: 'inline' | 'fullscreen' | 'picture-in-picture';
  webkitSetPresentationMode?: (mode: 'inline' | 'fullscreen' | 'picture-in-picture') => void;
};
@Component({
	selector: 'app-content-media',
	templateUrl: './content-media.component.html',
	styleUrls: ['./content-media.component.scss'],
})
export class ContentMediaComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  window_width;
  dictationTimer;
  currentIndex;
  totalSlides;
  SlideInteraction:boolean=true;
  index=0;
  checkIntervalId: any;

  timeoutId;
  currentTime: number = 0;
  duration;
  activeVideo: HTMLVideoElement | null = null;
  videoPaused = false;
  private seekingVideo = false;
  private suppressVideoTapUntil = 0;
  private pendingVideoTap: { video: HTMLVideoElement; timeout: any } | null = null;
  private readonly videoTapDelayMs = 280;
  private footerMutationObserver?: MutationObserver;
  private footerOffsetAnimationFrame?: number;
  private nativeFooterMetricsRequest = 0;
  private nativeFooterMetricsPending = false;
  private readonly footerSelector = 'app-footer-bar, .footer-glass-shell, .footer-glass-island, .footer-glass-bar, ion-footer, ion-tab-bar';
  private appStateListener?: PluginListenerHandle;
  videoOptionsOpenFor: HTMLVideoElement | null = null;
  downloadingVideo = false;
  /** The currently expanded landscape video. This reuses the feed's exact
   * player so entering the mobile landscape view never restarts or pauses it. */
  landscapeFullscreenVideo: HTMLVideoElement | null = null;
  private landscapeStage: HTMLElement | null = null;
  private landscapeProgressFrame: number | null = null;
  private landscapeProgressUpdatedAt = 0;
  private landscapeProgressElements: {
    range: HTMLInputElement;
    elapsed: HTMLElement;
    total: HTMLElement;
  } | null = null;
  private landscapePlaceholder: Comment | null = null;
  private landscapeBodyOverflow = '';
  private landscapePreviousFocus: HTMLElement | null = null;
  private readonly landscapeEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') this.closeLandscapeFullscreen(event);
  };
  /** Viewport coordinates for the compact landscape-expansion control. They
   * are derived from the actual object-fit: contain frame, not from the media
   * container, which includes letterboxing for horizontal videos. */
  landscapeFullscreenControlStyle: Record<string, string> = {};
  private landscapeFullscreenControlFrameId: number | null = null;
  private readonly visibilityChangeListener = (): void => {
    if (document.hidden) this.enterPictureInPictureForAudibleVideo();
  };
  videoPreload: 'metadata' = 'metadata';
  @ViewChild('videoElement') videoElement: ElementRef;
  slideOpts = {
    direction: 'horizontal',
    initialSlide: 0,
    speed: 400,

  };
  @ViewChildren('videoPlayer') videoPlayers: QueryList<any>; // access all video elements
  @ViewChild('media_slider', { static: false }) slider: IonSlides;
	@Input() multimedia: Array<MediaItem>;
	@Input() publication: any;
	@Output() savePublication = new EventEmitter();
	@Output() sharePublication = new EventEmitter();
  @Input() activeSlideIndex: number;
  @Input() currentSlideIndex: number;
  videoorPhotoMedia;
  audio;
  private clickCount = 0;
  private clickTimeout: any;
	private audioDurationTimer: any;
  private audioSetupTimeoutId: any;
  private slideUnlockTimeoutId: any;
  private destroyed = false;
  private autoAdvancePromptOpen = false;
  private pendingTimeouts = new Set<any>();
  private readonly resizeListener = (event: Event) => this.onResize(event);
	constructor(
		private modalController: ModalController,
    private actualizacionservice:ActualizacionServiceService,
    public formService:FormServiceService,
    private publication_template:PublicationMediaTemplateComponent,
    private request: RequestService,
    private zone: NgZone,
    private changeDetector: ChangeDetectorRef,
    private elementRef: ElementRef<HTMLElement>) {
      window.addEventListener('resize', this.resizeListener);
     }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeSlideIndex'] && this.isActivePublication()) this.scheduleFooterOffsetUpdate();
    if (!changes['activeSlideIndex'] || changes['activeSlideIndex'].firstChange || this.isActivePublication()) {
      return;
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.pendingTimeouts.delete(this.timeoutId);
      this.timeoutId = null;
    }
    this.cancelPendingVideoTap();
    this.closeLandscapeFullscreen();
    this.releaseAllMedia();
    if (this.autoAdvancePromptOpen) {
      Swal.close();
      this.autoAdvancePromptOpen = false;
    }
  }

    like_or_gift() {
      this.clickCount++;
  
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
      }
  
      // Set a timeout of 2 seconds to detect the click sequence
      this.clickTimeout = this.scheduleTimeout(() => {
        if (this.clickCount === 2) {
          // Handle double click
          console.log('Double click detected!');
          this.publication_template.click_on_like(this.publication);
        } else if (this.clickCount === 3) {
          // Handle triple click
          this.publication_template.presentToast(this.publication);
          console.log('Triple click detected!');
        }
        // Reset click count and timeout
        this.clickCount = 0;
        this.clickTimeout = null;
      }, 1800); // 2 seconds window
    }
	ngOnInit() {

	  this.videoorPhotoMedia = this.multimedia.filter(mul => mul.type === 'Video' || mul.type === 'Imagen');




    //console.log('Active slide index:', this.activeSlideIndex);
    //console.log('Current slide index:', this.currentSlideIndex);
  }

  videoPoster(media: any): string | null {
    const candidates = [
      media?.thumbnail_url,
      media?.thumbnailUrl,
      media?.preview_url,
      media?.previewUrl,
      this.publication?.thumbnail_url,
      this.publication?.thumbnailUrl,
      this.publication?.container?.thumbnail_url,
      this.publication?.container?.thumbnailUrl,
    ];

    const poster = candidates.find(candidate => typeof candidate === 'string' && candidate.trim() !== '');
    if (poster) return poster.trim();

    const publicationId = this.publication?.id ?? this.publication?.publication_id;
    return Number.isInteger(Number(publicationId)) && Number(publicationId) > 0
      ? `https://supercluster-api.laniakea.tv/api/share-preview/publication/${encodeURIComponent(String(publicationId))}/image`
      : null;
  }
  updateAudioDuration(event: Event){
    const audio = event.target as HTMLAudioElement;
    if (!this.isActivePublication()) {
      this.releaseMediaElement(audio);
      return;
    }

    if (Capacitor.getPlatform() === 'web') {
      audio.muted = false;
      void audio.play().catch(() => undefined);
    }
    console.log('audio duration', audio.duration);
  }
  updateAudioCurrentTime(){
   
  }
  ngOnDestroy() {
    this.destroyed = true;
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
    clearInterval(this.checkIntervalId);
    this.checkIntervalId = null;
    clearInterval(this.dictationTimer);
    this.dictationTimer = null;
    clearInterval(this.audioDurationTimer);
    this.audioDurationTimer = null;
    clearTimeout(this.clickTimeout);
    this.clickTimeout = null;
    clearTimeout(this.audioSetupTimeoutId);
    this.audioSetupTimeoutId = null;
    clearTimeout(this.slideUnlockTimeoutId);
    this.slideUnlockTimeoutId = null;
    this.cancelPendingVideoTap();
    this.pendingTimeouts.forEach((timeout) => clearTimeout(timeout));
    this.pendingTimeouts.clear();
    window.removeEventListener('resize', this.resizeListener);
    document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    this.appStateListener?.remove();
    this.footerMutationObserver?.disconnect();
    if (this.footerOffsetAnimationFrame) cancelAnimationFrame(this.footerOffsetAnimationFrame);
    if (this.landscapeFullscreenControlFrameId !== null) {
      cancelAnimationFrame(this.landscapeFullscreenControlFrameId);
      this.landscapeFullscreenControlFrameId = null;
    }
    this.closeLandscapeFullscreen();
    this.releaseAllMedia();
    if (this.autoAdvancePromptOpen) {
      Swal.close();
      this.autoAdvancePromptOpen = false;
    }
  }
  ngAfterViewInit() {
    this.installFooterOffsetTracking();
    this.installPictureInPictureBackgroundHandling();
    this.scheduleLandscapeFullscreenControlPosition();
    this.currentIndex =  this.slider.getActiveIndex();
    this.totalSlides =  this.slider.length();
      this.checkIntervalId = setInterval(() => {
        if (this.destroyed || this.landscapeFullscreenVideo || !this.isActivePublication()) return;
        if(this.SlideInteraction){
          this.SlideInteraction=false;
          this.timeoutId = this.scheduleTimeout(() => {
            this.SlideInteraction=true;
          }, 3000);
       // console.log('status,', this.formService.changeMediaPeriodically);
        //console.log('status2,', this.duration);
        if(this.formService.user_diasabled_autoswipe ){
          return;
        }
if((!this.formService.changeMediaPeriodically||this.duration) && this.formService.user_diasabled_autoswipe){
  return;
}else{
          this.autoAdvancePromptOpen = true;
          Swal.fire({
            title: 'Siguiente',
            text: ``,
            icon: 'info',
            timer: 6900, // Show the alert for 6.9 seconds
            timerProgressBar: true,
            toast: true,
            position: 'bottom-end',
            showCancelButton: true,
          showConfirmButton:true,
            cancelButtonText: '<ion-icon name="reload"></ion-icon>No',
            confirmButtonText: '<ion-icon name="play-skip-forward-sharp"></ion-icon>Si',
            color: 'black',
            background: 'white',
            }).then((result) => {
              this.autoAdvancePromptOpen = false;
              if (this.destroyed) return;
              this.formService.changeMediaPeriodically=false;
              clearTimeout(this.timeoutId);
              if (result.isConfirmed) {
                this.formService.changeMediaPeriodically=true;
                void this.Next();
              } else {
                this.formService.changeMediaPeriodically=false;
                this.timeoutId=null;
              }
            });
    
            // Set a timeout to call getRandomPosts if there is no interaction from the user
     this.timeoutId = this.scheduleTimeout(() => {
      if (this.destroyed || !this.isActivePublication()) return;
      if(this.duration){
        return; 
      }
      if(!this.formService.changeMediaPeriodically){
        return;
      }
      this.Next();
    }, 6300);
        
  }
}
      }, 6900);

    
      
   
  }

  updateCurrentTime(event: Event) {//displays the alert to change when video ended

    const video = event.target as HTMLVideoElement;
    this.activeVideo = video;
    this.currentTime = video.currentTime;
    // Fullscreen loops belong to the player, not the feed auto-advance flow.
    if (this.landscapeFullscreenVideo === video) return;
    //console.log('duration', this.duration);
    const publication = this.formService.publications[this.formService.publication_template_index];

    this.duration = video.duration;
    //console.log('durationnn', this.duration);
    //console.log('currentTimeee', this.currentTime);

    if(this.formService.user_diasabled_autoswipe ){
      return;
    }
    if(!this.formService.changeMediaPeriodically){
      return;
    }
    if(video.duration==this.duration && this.formService.actual_publication === publication){
      console.log('current same video, next alert can only be dipslayed once for a media')
      return;
    }
    if (this.currentTime >= video.duration - 6 && !this.timeoutId) {
      console.log('Video is at the end or within 6 seconds of the end.');
      // You can add additional logic here, e.g., displaying an alert or performing an action

      this.autoAdvancePromptOpen = true;
      Swal.fire({
				title: 'Siguiente',
				text: ``,
				icon: 'info',
				timer: 6900, // Show the alert for 6.9 seconds
				timerProgressBar: true,
				toast: true,
				position: 'bottom-end',
				showCancelButton: true,
			showConfirmButton:true,
				cancelButtonText: '<ion-icon name="reload"></ion-icon>No',
        confirmButtonText: '<ion-icon name="play-skip-forward-sharp"></ion-icon>Si',
				color: 'black',
				background: 'white',
        }).then((result) => {
          this.autoAdvancePromptOpen = false;
          if (this.destroyed) return;
          this.formService.changeMediaPeriodically=false;
          clearTimeout(this.timeoutId);
          clearInterval(this.timeoutId);
				if (result.isConfirmed) {
          this.formService.changeMediaPeriodically=true;
this.Next();
this.currentTime=null;
				}else{
          this.formService.changeMediaPeriodically=false;
          clearTimeout(this.timeoutId);
          clearInterval(this.timeoutId);
          this.duration=null;

          //play again the video
				}
			  });

        // Set a timeout to call getRandomPosts if there is no interaction from the user
 this.timeoutId = this.scheduleTimeout(() => {
  if (this.destroyed || !this.isActivePublication()) return;


  this.Next();
  this.currentTime=null;
}, 6300);
    }
  }
async Next(){
  if (this.landscapeFullscreenVideo) return;
  console.log('status final,', this.formService.changeMediaPeriodically);
  if(!this.formService.changeMediaPeriodically){
    return;
  }
  this.currentTime=0;
  clearInterval(this.timeoutId);
  this.duration=null;
  this.timeoutId=null;
console.log('nextpost called');

  this.nextMedia();



}	  openComponentVideo(fetchedPublications){
		
  this.formService.mostrar = false;
 this.formService.publications=fetchedPublications;
  this.formService.valueSelect= 'MENU';
  this.formService.mediaTemplate=true;

  }
  currentlyPlayingVideo = null;
  checkMedia;
  updateDuration(event: Event) {
    const video = event.target as HTMLVideoElement;
    clearInterval(this.dictationTimer);
    this.dictationTimer = null;

    if (!this.isActivePublication()) {
      if (!this.publication_template.isPreloadedVideo(video)) {
        this.releaseMediaElement(video);
      }
      return;
    }

    this.syncActiveVideoMetadata(video);
  }

  private syncActiveVideoMetadata(video: HTMLVideoElement): void {
    if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
      this.currentlyPlayingVideo.muted = true;
      this.currentlyPlayingVideo.pause();
    }

    this.currentlyPlayingVideo = video;
    this.activeVideo = video;
    this.videoPaused = video.paused;
    this.duration = Number.isFinite(video.duration) ? video.duration : null;
    this.formService.actual_publication = this.publication;
    this.scheduleLandscapeFullscreenControlPosition(video);
  }

  isLandscapeVideo(video: HTMLVideoElement): boolean {
    return video?.videoWidth > 0 && video?.videoHeight > 0
      && video.videoWidth / video.videoHeight > 1.15;
  }

  showLandscapeFullscreenControl(video: HTMLVideoElement): boolean {
    return this.isLandscapeVideo(video);
  }

  openLandscapeFullscreen(event: Event, video: HTMLVideoElement): void {
    // Activate on the initial press rather than waiting for a synthesized click
    // that the surrounding slide gesture can consume. Keep click for keyboard use.
    if (event.type === 'pointerdown') {
      const pointer = event as PointerEvent;
      if (!pointer.isPrimary || pointer.button !== 0) return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (this.destroyed || !video?.isConnected) return;
    if (!this.showLandscapeFullscreenControl(video)) return;
    if (this.landscapeFullscreenVideo === video) return;
    this.closeLandscapeFullscreen();
    const stage = video.closest('.relacionIMG') as HTMLElement | null;
    if (!stage?.parentNode) return;
    const wasPlaying = !video.paused;
    this.cancelPendingVideoTap();
    this.suppressVideoTapUntil = Date.now() + 500;
    this.activeVideo = video;
    this.videoPaused = video.paused;
    if (this.landscapeFullscreenControlFrameId !== null) {
      cancelAnimationFrame(this.landscapeFullscreenControlFrameId);
      this.landscapeFullscreenControlFrameId = null;
    }
    this.landscapePreviousFocus = document.activeElement as HTMLElement;
    this.landscapePlaceholder = document.createComment('inline-video-position');
    stage.parentNode.insertBefore(this.landscapePlaceholder, stage);
    this.landscapeStage = stage;

    this.landscapeFullscreenVideo = video;
    // Discard any footer measurement already crossing the native bridge.
    ++this.nativeFooterMetricsRequest;
    if (this.footerOffsetAnimationFrame) cancelAnimationFrame(this.footerOffsetAnimationFrame);
    this.footerOffsetAnimationFrame = undefined;
    this.videoOptionsOpenFor = null;
    this.landscapeBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('laniakea-landscape-video-open');
    stage.classList.add('native-landscape-viewer');
    stage.setAttribute('role', 'dialog');
    stage.setAttribute('aria-modal', 'true');
    stage.setAttribute('aria-label', this.publication?.title || 'Video');
    stage.tabIndex = -1;
    // Build the controls in this turn, before moving the stage out of the slide.
    // Entry must not depend on another user interaction triggering a render.
    this.changeDetector.detectChanges();
    document.body.appendChild(stage);
    this.updateLandscapeStageSize();
    this.startLandscapeProgressTracking();
    stage.focus({ preventScroll: true });
    document.addEventListener('keydown', this.landscapeEscape);
    window.visualViewport?.addEventListener('resize', this.resizeListener);
    if (Capacitor.isNativePlatform()) {
      void NativeLiquidGlass.setChromeSuppressed({ suppressed: true }).catch(() => undefined);
    }
    if (wasPlaying && video.paused) void video.play().catch(() => undefined);
  }

  private startLandscapeProgressTracking(): void {
    this.stopLandscapeProgressTracking();
    this.landscapeProgressUpdatedAt = 0;
    // Read the media clock directly across loop/seek boundaries. Updating only
    // these controls avoids running change detection across every feed slide.
    this.zone.runOutsideAngular(() => {
      const tick = (timestamp: number) => {
        if (!this.landscapeFullscreenVideo || this.destroyed) return;
        if (timestamp - this.landscapeProgressUpdatedAt >= 100) {
          this.renderLandscapeProgress();
          this.landscapeProgressUpdatedAt = timestamp;
        }
        this.landscapeProgressFrame = requestAnimationFrame(tick);
      };
      this.landscapeProgressFrame = requestAnimationFrame(tick);
    });
  }

  private renderLandscapeProgress(): void {
    const video = this.landscapeFullscreenVideo;
    if (!video || !this.landscapeStage) return;
    if (!this.landscapeProgressElements) {
      const range = this.landscapeStage.querySelector<HTMLInputElement>('.native-landscape-progress input');
      const elapsed = this.landscapeStage.querySelector<HTMLElement>('.native-landscape-elapsed');
      const total = this.landscapeStage.querySelector<HTMLElement>('.native-landscape-total');
      // Angular creates the controls after the fullscreen click has completed.
      if (!range || !elapsed || !total) return;
      this.landscapeProgressElements = { range, elapsed, total };
    }
    const { range, elapsed, total } = this.landscapeProgressElements;
    const duration = this.videoDurationFor(video);
    const max = String(duration);
    if (range.max !== max) range.max = max;
    if (!this.seekingVideo) {
      const value = String(this.videoCurrentTimeFor(video));
      // Avoid mutating the DOM on every tick while playback is paused/stalled.
      if (range.value !== value) range.value = value;
      const background = this.videoProgressBackground(video, '#fff');
      if (range.dataset.progressBackground !== background) {
        range.style.background = background;
        range.dataset.progressBackground = background;
      }
    }
    const elapsedText = this.formatVideoTime(this.videoCurrentTimeFor(video));
    const totalText = ` / ${this.formatVideoTime(duration)}`;
    if (elapsed.textContent !== elapsedText) elapsed.textContent = elapsedText;
    if (total.textContent !== totalText) total.textContent = totalText;
  }

  private stopLandscapeProgressTracking(): void {
    if (this.landscapeProgressFrame !== null) cancelAnimationFrame(this.landscapeProgressFrame);
    this.landscapeProgressFrame = null;
    this.landscapeProgressElements = null;
    this.seekingVideo = false;
  }

  private updateLandscapeStageSize(): void {
    if (!this.landscapeStage) return;
    const width = window.visualViewport?.width || window.innerWidth;
    const height = window.visualViewport?.height || window.innerHeight;
    this.landscapeStage.style.setProperty('--landscape-player-width', `${Math.max(width, height)}px`);
    this.landscapeStage.style.setProperty('--landscape-player-height', `${Math.min(width, height)}px`);
    this.landscapeStage.style.setProperty('--landscape-player-rotation', width < height ? '90deg' : '0deg');
  }

  landscapeAuthorPhoto(): string {
    return this.publication_template.profilePhotoFor(this.publication);
  }

  hasLandscapeCaptions(video: HTMLVideoElement): boolean {
    return Array.from(video.textTracks || []).some(track => track.kind === 'captions' || track.kind === 'subtitles');
  }

  landscapeCaptionsEnabled(video: HTMLVideoElement): boolean {
    return Array.from(video.textTracks || []).some(track => track.mode === 'showing');
  }

  toggleLandscapeCaptions(event: Event, video: HTMLVideoElement): void {
    event.stopPropagation();
    const enable = !this.landscapeCaptionsEnabled(video);
    let selected = false;
    Array.from(video.textTracks || []).forEach(track => {
      if (track.kind !== 'captions' && track.kind !== 'subtitles') return;
      track.mode = enable && !selected ? 'showing' : 'disabled';
      selected = true;
    });
  }

  /**
   * The media element fills its slide while `object-fit: contain` draws a
   * smaller horizontal frame inside it. Measure that frame after layout and
   * attach the control exactly at its lower edge: no guessed margin or padding.
   */
  private scheduleLandscapeFullscreenControlPosition(video?: HTMLVideoElement): void {
    if (this.landscapeFullscreenControlFrameId !== null) {
      cancelAnimationFrame(this.landscapeFullscreenControlFrameId);
    }
    this.landscapeFullscreenControlFrameId = requestAnimationFrame(() => {
      this.landscapeFullscreenControlFrameId = null;
      this.updateLandscapeFullscreenControlPosition(video);
    });
  }

  private updateLandscapeFullscreenControlPosition(video?: HTMLVideoElement): void {
    const target = video || this.activeVideo || this.videoPlayers?.first?.nativeElement;
    if (target && target === this.landscapeFullscreenVideo) return;
    if (!target || !this.isLandscapeVideo(target)) {
      this.landscapeFullscreenControlStyle = {};
      return;
    }

    const bounds = target.getBoundingClientRect();
    const containerBounds = target.closest('.relacionIMG')?.getBoundingClientRect();
    if (!containerBounds) return;
    if (bounds.width <= 0 || bounds.height <= 0) return;

    const intrinsicRatio = target.videoWidth / target.videoHeight;
    const boxRatio = bounds.width / bounds.height;
    const renderedHeight = intrinsicRatio >= boxRatio
      ? bounds.width / intrinsicRatio
      : bounds.height;
    const renderedTop = bounds.top + ((bounds.height - renderedHeight) / 2);
    const renderedBottom = renderedTop + renderedHeight;

    this.landscapeFullscreenControlStyle = {
      left: `${Math.round(bounds.left + (bounds.width / 2) - containerBounds.left)}px`,
      top: `${Math.round(renderedBottom - containerBounds.top)}px`,
    };
  }

  closeLandscapeFullscreen(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.stopLandscapeProgressTracking();
    if (!this.landscapeStage) return;
    this.cancelPendingVideoTap();
    const video = this.landscapeFullscreenVideo;
    const wasPlaying = video && !video.paused && !this.destroyed;
    const stage = this.landscapeStage;
    if (this.landscapePlaceholder?.parentNode) {
      this.landscapePlaceholder.parentNode.insertBefore(stage, this.landscapePlaceholder);
    } else {
      stage.remove();
    }
    this.landscapePlaceholder?.remove();
    stage.classList.remove('native-landscape-viewer');
    stage.removeAttribute('role');
    stage.removeAttribute('aria-modal');
    stage.removeAttribute('aria-label');
    stage.removeAttribute('tabindex');
    this.landscapePlaceholder = null;
    this.landscapeStage = null;
    this.landscapeFullscreenVideo = null;
    this.videoOptionsOpenFor = null;
    document.body.style.overflow = this.landscapeBodyOverflow;
    document.body.classList.remove('laniakea-landscape-video-open');
    document.removeEventListener('keydown', this.landscapeEscape);
    window.visualViewport?.removeEventListener('resize', this.resizeListener);
    if (Capacitor.isNativePlatform()) {
      void NativeLiquidGlass.setChromeSuppressed({ suppressed: false })
        .then(() => this.scheduleFooterOffsetUpdate())
        .catch(() => undefined);
    }
    if (this.landscapePreviousFocus?.isConnected) this.landscapePreviousFocus.focus({ preventScroll: true });
    this.landscapePreviousFocus = null;
    if (wasPlaying && video.paused) void video.play().catch(() => undefined);
    if (!this.destroyed) {
      this.scheduleLandscapeFullscreenControlPosition(video);
      this.scheduleFooterOffsetUpdate();
      this.notifyPublicationScrubberGeometryChanged();
    }
  }

  landscapeAction(event: Event, action: 'like' | 'comment' | 'save' | 'share'): void {
    event.preventDefault();
    event.stopPropagation();
    if (action === 'like') {
      this.publication_template.click_on_like(this.publication);
    } else if (action === 'comment') {
      this.closeLandscapeFullscreen();
      void this.publication_template.click_on_comments(this.publication);
    } else if (action === 'save') {
      this.publication_template.click_on_save(this.publication);
    } else {
      this.closeLandscapeFullscreen();
      void this.publication_template.presentActionSheet(this.publication);
    }
  }

  toggleLandscapePlayback(event: Event, video: HTMLVideoElement): void {
    event.preventDefault();
    event.stopPropagation();
    this.activeVideo = video;
    this.applyVideoPlaybackToggle(video);
  }

  toggleVideoPlayback(event: Event, video: HTMLVideoElement): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.type === 'click' && Date.now() < this.suppressVideoTapUntil) return;
    this.activeVideo = video;

    // Delay a single tap briefly. A second quick tap is a like gesture, so it
    // must cancel the pending pause and leave an already-playing video alone.
    if (event.type === 'click') {
      if (this.pendingVideoTap?.video === video) {
        this.cancelPendingVideoTap();
        this.publication_template.click_on_like(this.publication);
        return;
      }

      this.cancelPendingVideoTap();
      const timeout = this.scheduleTimeout(() => {
        this.pendingVideoTap = null;
        this.applyVideoPlaybackToggle(video);
      }, this.videoTapDelayMs);
      this.pendingVideoTap = { video, timeout };
      return;
    }

    this.applyVideoPlaybackToggle(video);
  }

  private applyVideoPlaybackToggle(video: HTMLVideoElement): void {
    if (video.paused || video.ended) {
      if (video.ended) video.currentTime = 0;
      void video.play().catch(() => {
        this.videoPaused = true;
      });
      return;
    }

    video.pause();
  }

  private cancelPendingVideoTap(): void {
    if (!this.pendingVideoTap) return;
    clearTimeout(this.pendingVideoTap.timeout);
    this.pendingTimeouts.delete(this.pendingVideoTap.timeout);
    this.pendingVideoTap = null;
  }

  resumeVideoFromControl(event: Event, video: HTMLVideoElement): void {
    // A pointer press removes the play button as playback begins. Some mobile
    // browsers then dispatch the matching click to the video beneath it.
    this.suppressVideoTapUntil = Date.now() + 350;
    event.preventDefault();
    event.stopPropagation();
    this.cancelPendingVideoTap();
    this.activeVideo = video;
    this.applyVideoPlaybackToggle(video);
  }

  onVideoPlay(video: HTMLVideoElement): void {
    // A warmed video has already fired loadedmetadata while it was inactive.
    // Populate its controls when promoted without reloading the buffered source.
    if (this.isActivePublication() && video.readyState >= 1 && this.currentlyPlayingVideo !== video) {
      this.syncActiveVideoMetadata(video);
    }
    this.activeVideo = video;
    this.videoPaused = false;
    this.notifyPublicationScrubberGeometryChanged();
  }

  onVideoPause(video: HTMLVideoElement): void {
    this.activeVideo = video;
    this.videoPaused = true;
    this.updateScrubberFooterOffset();
    // The paused-state template creates the scrubber after this handler.
    // Notify the owning publication on the next frame, when it has geometry.
    this.notifyPublicationScrubberGeometryChanged();
  }

  private notifyPublicationScrubberGeometryChanged(): void {
    if (this.destroyed || this.landscapeFullscreenVideo) return;
    requestAnimationFrame(() => {
      if (this.destroyed || this.landscapeFullscreenVideo) return;
      this.elementRef.nativeElement.dispatchEvent(new CustomEvent('publicationScrubberGeometryChanged', {
        bubbles: true,
        composed: true,
        detail: { paused: this.videoPaused },
      }));
    });
  }

  /**
   * Keep the seek bar directly above the currently visible footer. Angular
   * footer bounds are measured in the DOM; UIKit footer bounds come through
   * the native bridge in equivalent WebView coordinates.
   */
  private installFooterOffsetTracking(): void {
    // These measurements only write CSS. Do not start Angular change detection
    // for every mutation or native bridge response in a feed with many slides.
    this.zone.runOutsideAngular(() => {
      this.updateScrubberFooterOffset();
      this.footerMutationObserver = new MutationObserver(records => {
        if (records.some(record => this.isFooterMutation(record))) this.scheduleFooterOffsetUpdate();
      });
      this.footerMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      });
    });
  }

  private isFooterMutation(record: MutationRecord): boolean {
    if (record.type === 'attributes') {
      return record.target === document.body
        || (record.target instanceof Element && !!record.target.closest(this.footerSelector));
    }
    return [...Array.from(record.addedNodes), ...Array.from(record.removedNodes)]
      .some(node => node instanceof Element
        && (node.matches(this.footerSelector) || !!node.querySelector(this.footerSelector)));
  }

  private shouldTrackFooter(): boolean {
    return !this.destroyed && this.isActivePublication()
      && !document.body.classList.contains('laniakea-landscape-video-open')
      && !this.elementRef.nativeElement.closest('.ion-page-hidden, [aria-hidden="true"]');
  }

  private scheduleFooterOffsetUpdate(): void {
    if (this.footerOffsetAnimationFrame || !this.shouldTrackFooter()) return;
    this.zone.runOutsideAngular(() => {
      this.footerOffsetAnimationFrame = requestAnimationFrame(() => {
        this.footerOffsetAnimationFrame = undefined;
        this.updateScrubberFooterOffset();
      });
    });
  }

  private updateScrubberFooterOffset(): void {
    if (!this.shouldTrackFooter()) return;
    if (document.body.classList.contains('native-liquid-footer')) {
      this.zone.runOutsideAngular(() => this.updateNativeFooterOffset());
      return;
    }

    const viewportHeight = window.innerHeight;
    // `.video-scrubber-shell` is absolutely positioned inside `.relacionIMG`,
    // not the viewport. Its offset therefore must use that media frame's
    // bottom edge, otherwise a full-screen card/footer layout drifts.
    const mediaFrame = this.activeVideo?.closest('.relacionIMG') as HTMLElement | null;
    const mediaFrameBottom = mediaFrame?.getBoundingClientRect().bottom ?? viewportHeight;
    let footerClearance = 0;
    const selectors = [
      'app-footer-bar',
      '.footer-glass-shell',
      '.footer-glass-island',
      '.footer-glass-bar',
      'ion-footer',
      'ion-tab-bar',
    ].join(',');

    document.querySelectorAll<HTMLElement>(selectors).forEach((footer) => {
      const styles = window.getComputedStyle(footer);
      if (styles.display === 'none' || styles.visibility === 'hidden' || Number(styles.opacity) === 0) return;
      const rect = footer.getBoundingClientRect();
      // Only fixed/absolute footer surfaces at the bottom of the viewport are
      // relevant. Ordinary footers in a scrollable page must not move the bar.
      if (rect.height <= 0 || rect.top < viewportHeight / 2 || rect.bottom < viewportHeight - 24) return;
      const exactOffsetToFooterTop = Math.max(0, mediaFrameBottom - rect.top);
      footerClearance = Math.max(footerClearance, Math.ceil(exactOffsetToFooterTop + 8));
    });

    this.setScrubberFooterClearance(`${footerClearance}px`);
  }

  private updateNativeFooterOffset(): void {
    if (this.nativeFooterMetricsPending || !this.shouldTrackFooter()) return;
    this.nativeFooterMetricsPending = true;
    const request = ++this.nativeFooterMetricsRequest;
    NativeLiquidGlass.getFooterMetrics()
      .then((metrics) => {
        if (request !== this.nativeFooterMetricsRequest || !this.shouldTrackFooter() || !document.body.classList.contains('native-liquid-footer')) return;
        if (!metrics.available || !metrics.visible || !Number.isFinite(metrics.footerTop) || !Number.isFinite(metrics.webViewHeight) || (metrics.webViewHeight || 0) <= 0) {
          this.setScrubberFooterClearance('0px');
          return;
        }

        const mediaFrame = this.activeVideo?.closest('.relacionIMG') as HTMLElement | null;
        const mediaFrameBottom = mediaFrame?.getBoundingClientRect().bottom ?? window.innerHeight;
        const footerTopInCssPixels = (metrics.footerTop as number) * (window.innerHeight / (metrics.webViewHeight as number));
        // This is the same calculation used for the Angular footer: the
        // positioned media frame's bottom to the actual dock's top edge.
        const clearance = Math.max(0, Math.ceil(mediaFrameBottom - footerTopInCssPixels + 8));
        this.setScrubberFooterClearance(`${clearance}px`);
      })
      .catch(() => {
        if (request === this.nativeFooterMetricsRequest && this.shouldTrackFooter()) this.setScrubberFooterClearance('0px');
      })
      .finally(() => {
        this.nativeFooterMetricsPending = false;
        if (request !== this.nativeFooterMetricsRequest) this.scheduleFooterOffsetUpdate();
      });
  }

  private installPictureInPictureBackgroundHandling(): void {
    document.addEventListener('visibilitychange', this.visibilityChangeListener);
    if (!Capacitor.isNativePlatform()) return;

    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) this.enterPictureInPictureForAudibleVideo();
    })
      .then(listener => this.appStateListener = listener)
      .catch(() => undefined);
  }

  /**
   * iOS receives its app-state transition before the WebView is suspended.
   * Enter PiP at that point only for intentionally audible playback; muted
   * feed videos must never create a floating player when the app backgrounds.
   */
  private enterPictureInPictureForAudibleVideo(): void {
    const video = this.activeVideo;
    if (!video || video.paused || video.ended || video.muted || video.volume <= 0 || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      return;
    }

    const webkitVideo = video as WebKitPictureInPictureVideo;
    if (typeof webkitVideo.webkitSetPresentationMode === 'function') {
      if (webkitVideo.webkitPresentationMode !== 'picture-in-picture') {
        try {
          webkitVideo.webkitSetPresentationMode('picture-in-picture');
        } catch {
          // PiP can be unavailable for DRM-protected or system-restricted media.
        }
      }
      return;
    }

    if (document.pictureInPictureEnabled && document.pictureInPictureElement !== video && typeof video.requestPictureInPicture === 'function') {
      void video.requestPictureInPicture().catch(() => undefined);
    }
  }

  private setScrubberFooterClearance(value: string): void {
    const hostStyle = this.elementRef.nativeElement.style;
    if (hostStyle.getPropertyValue('--publication-media-footer-clearance') !== value) {
      hostStyle.setProperty('--publication-media-footer-clearance', value);
    }
  }

  isVideoPaused(video: HTMLVideoElement): boolean {
    return this.activeVideo === video ? this.videoPaused : video?.paused === true;
  }

  videoDurationFor(video: HTMLVideoElement): number {
    return Number.isFinite(video?.duration) && video.duration > 0 ? video.duration : 0;
  }

  videoCurrentTimeFor(video: HTMLVideoElement): number {
    return Number.isFinite(video?.currentTime) ? video.currentTime : 0;
  }

  videoProgressBackground(video: HTMLVideoElement, fill = '#fe2c55'): string {
    const duration = this.videoDurationFor(video);
    const percentage = duration > 0 ? Math.min(100, Math.max(0, (this.videoCurrentTimeFor(video) / duration) * 100)) : 0;
    return `linear-gradient(to right, ${fill} 0%, ${fill} ${percentage}%, rgba(255, 255, 255, .38) ${percentage}%, rgba(255, 255, 255, .38) 100%)`;
  }

  formatVideoTime(value: number): string {
    if (!Number.isFinite(value) || value < 0) return '0:00';
    const wholeSeconds = Math.floor(value);
    return `${Math.floor(wholeSeconds / 60)}:${String(wholeSeconds % 60).padStart(2, '0')}`;
  }

  beginVideoSeek(event: Event): void {
    event.stopPropagation();
    this.seekingVideo = true;
    const pointer = event as PointerEvent;
    const input = event.target as HTMLInputElement;
    if (typeof pointer.pointerId === 'number') input.setPointerCapture?.(pointer.pointerId);
  }

  endVideoSeek(event: Event): void {
    event.stopPropagation();
    this.seekingVideo = false;
    this.renderLandscapeProgress();
  }

  seekVideo(event: Event, video: HTMLVideoElement): void {
    event.stopPropagation();
    const input = event.target as HTMLInputElement;
    const nextTime = Number(input?.value);
    if (!Number.isFinite(nextTime) || !Number.isFinite(video?.duration)) return;
    this.activeVideo = video;
    video.currentTime = Math.max(0, Math.min(nextTime, video.duration));
    this.currentTime = video.currentTime;
    if (this.landscapeFullscreenVideo === video) {
      input.style.background = this.videoProgressBackground(video, '#fff');
      this.renderLandscapeProgress();
    }
  }

  toggleVideoOptions(event: Event, video: HTMLVideoElement): void {
    event.preventDefault();
    event.stopPropagation();
    this.activeVideo = video;
    this.videoOptionsOpenFor = this.videoOptionsOpenFor === video ? null : video;
  }

  toggleVideoMute(event: Event, video: HTMLVideoElement): void {
    event.preventDefault();
    event.stopPropagation();
    video.muted = !video.muted;
    if (!video.muted && video.volume === 0) video.volume = 1;
  }

  cycleVideoPlaybackRate(event: Event, video: HTMLVideoElement): void {
    event.preventDefault();
    event.stopPropagation();
    const rates = [0.5, 0.75, 1, 1.25, 1.5, 2];
    const currentIndex = rates.findIndex(rate => Math.abs(rate - video.playbackRate) < 0.01);
    video.playbackRate = rates[(currentIndex + 1 + rates.length) % rates.length];
  }

  videoDownloadAvailable(media: any): boolean {
    return Number.isInteger(Number(media?.id ?? media?.multimedia_id))
      && Number(media?.is_premium ?? 0) !== 1;
  }

  async downloadWatermarkedVideo(event: Event, media: any, video: HTMLVideoElement): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    const mediaId = Number(media?.id ?? media?.multimedia_id);
    if (!this.videoDownloadAvailable(media) || this.downloadingVideo) return;

    this.downloadingVideo = true;
    try {
      const file = await this.createWatermarkedVideoOnDevice(video);
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = `laniakea-${mediaId}.${file.type.includes('mp4') ? 'mp4' : 'webm'}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      this.videoOptionsOpenFor = null;
    } catch (error) {
      console.error('Unable to prepare watermarked video download.', error);
      Swal.fire({ icon: 'error', text: 'No fue posible preparar la descarga con marca de agua.' });
    } finally {
      this.downloadingVideo = false;
    }
  }

  private async createWatermarkedVideoOnDevice(sourceVideo: HTMLVideoElement): Promise<Blob> {
    const sourceUrl = sourceVideo.currentSrc || sourceVideo.src || sourceVideo.querySelector('source')?.src;
    if (!sourceUrl || typeof MediaRecorder === 'undefined') {
      throw new Error('This device cannot create a watermarked video download.');
    }

    const input = document.createElement('video');
    input.crossOrigin = 'anonymous';
    // The feed player has already fetched this URL in normal media mode.
    // Chromium may reuse that non-CORS cache entry for the recorder and reject
    // it even though S3 correctly returns ACAO for a new CORS request. A
    // harmless cache key gives the recorder its own anonymous CORS response.
    input.src = this.watermarkSourceUrl(sourceUrl);
    input.preload = 'auto';
    input.playsInline = true;
    input.muted = true;
    input.style.cssText = 'position:fixed; width:1px; height:1px; opacity:0; pointer-events:none; left:-10px; top:-10px;';
    document.body.appendChild(input);

    let audioContext: AudioContext | undefined;
    try {
      await this.waitForMediaMetadata(input);
      const logo = await this.loadWatermarkLogo();
      const canvas = document.createElement('canvas');
      canvas.width = input.videoWidth;
      canvas.height = input.videoHeight;
      const context = canvas.getContext('2d');
      if (!context || canvas.width < 1 || canvas.height < 1 || typeof canvas.captureStream !== 'function') {
        throw new Error('Canvas video capture is unavailable.');
      }

      const canvasStream = canvas.captureStream(30);
      const outputStream = new MediaStream(canvasStream.getVideoTracks());
      audioContext = new AudioContext();
      const audioDestination = audioContext.createMediaStreamDestination();
      audioContext.createMediaElementSource(input).connect(audioDestination);
      audioDestination.stream.getAudioTracks().forEach(track => outputStream.addTrack(track));
      input.muted = false;
      input.volume = 1;

      const mimeType = this.supportedWatermarkedVideoMimeType();
      const recorder = new MediaRecorder(outputStream, mimeType ? { mimeType } : undefined);
      const chunks: BlobPart[] = [];
      recorder.ondataavailable = ({ data }) => { if (data.size > 0) chunks.push(data); };

      let frameId = 0;
      const drawFrame = (): void => {
        context.drawImage(input, 0, 0, canvas.width, canvas.height);
        this.drawLaniakeaWatermark(context, logo, canvas.width, canvas.height, input.currentTime);
        frameId = requestAnimationFrame(drawFrame);
      };

      const finished = new Promise<Blob>((resolve, reject) => {
        recorder.onerror = () => reject(new Error('Video recorder failed.'));
        recorder.onstop = () => resolve(new Blob(chunks, { type: recorder.mimeType || 'video/webm' }));
        input.onended = () => recorder.state !== 'inactive' && recorder.stop();
      });
      await audioContext.resume();
      recorder.start(1000);
      drawFrame();
      await input.play();
      const output = await finished;
      cancelAnimationFrame(frameId);
      if (output.size < 1024) throw new Error('The watermarked recording is empty.');
      return output;
    } finally {
      audioContext?.close().catch(() => undefined);
      input.pause();
      input.removeAttribute('src');
      input.load();
      input.remove();
    }
  }

  private waitForMediaMetadata(video: HTMLVideoElement): Promise<void> {
    if (video.readyState >= HTMLMediaElement.HAVE_METADATA) return Promise.resolve();
    return new Promise((resolve, reject) => {
      video.onloadedmetadata = () => resolve();
      video.onerror = () => reject(new Error('Unable to read the video on this device.'));
    });
  }

  private watermarkSourceUrl(sourceUrl: string): string {
    try {
      const url = new URL(sourceUrl, window.location.href);
      // Never alter a presigned URL: its query string is part of the AWS
      // signature and must remain byte-for-byte intact.
      if (!url.searchParams.has('X-Amz-Signature')) {
        url.searchParams.set('laniakea-watermark-read', String(Date.now()));
      }
      return url.toString();
    } catch {
      return sourceUrl;
    }
  }

  private loadWatermarkLogo(): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.onload = () => resolve(logo);
      logo.onerror = () => reject(new Error('Unable to load the Laniakea watermark.'));
      logo.src = 'https://laniakea-multimedia.s3.us-east-1.amazonaws.com/laniakea.tv/Frame+54+Background+Removed.png';
    });
  }

  private drawLaniakeaWatermark(context: CanvasRenderingContext2D, logo: HTMLImageElement, width: number, height: number, time: number): void {
    const watermarkWidth = Math.max(64, Math.round(width * 0.14));
    const watermarkHeight = Math.round(watermarkWidth * (logo.naturalHeight / logo.naturalWidth));
    const margin = Math.max(16, Math.round(width * 0.025));
    const corners = [
      { x: margin, y: margin },
      { x: width - watermarkWidth - margin, y: margin },
      { x: width - watermarkWidth - margin, y: height - watermarkHeight - margin },
      { x: margin, y: height - watermarkHeight - margin },
    ];
    const corner = corners[Math.floor(Math.max(0, time) / 3) % corners.length];
    context.globalAlpha = 0.9;
    context.drawImage(logo, corner.x, corner.y, watermarkWidth, watermarkHeight);
    context.globalAlpha = 1;
  }

  private supportedWatermarkedVideoMimeType(): string | undefined {
    return [
      'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
      'video/webm',
    ].find(type => MediaRecorder.isTypeSupported(type));
  }

  mediaSource(media: any): string | null {
    return media?.url || media?.localUrl || media?.route || media?.mediaPath || null;
  }

  audioMediaSource(): string | null {
    const audioMedia = (this.multimedia || []).find((media) => media?.type === 'Audio');
    return this.mediaSource(audioMedia);
  }

  private isActivePublication(): boolean {
    return Number(this.activeSlideIndex) === Number(this.currentSlideIndex);
  }

  private releaseMediaElement(media: HTMLMediaElement): void {
    media.muted = true;
    media.pause();
    media.removeAttribute('autoplay');
    media.removeAttribute('src');
    media.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
    try {
      media.load();
    } catch {}
  }

  private releaseAllMedia(): void {
    const mediaElements = this.elementRef.nativeElement.querySelectorAll('video, audio');
    mediaElements.forEach((media) => this.releaseMediaElement(media as HTMLMediaElement));
    this.currentlyPlayingVideo = null;
  }

  private scheduleTimeout(callback: () => void, delay: number): any {
    const timeout = setTimeout(() => {
      this.pendingTimeouts.delete(timeout);
      if (!this.destroyed) callback();
    }, delay);
    this.pendingTimeouts.add(timeout);
    return timeout;
  }
  
  ReadySetPlayVideo(videoPlayer: HTMLVideoElement) {
    if (videoPlayer) {
      console.log('Playback rate:', videoPlayer.playbackRate);
      console.log('Active slide index:', this.activeSlideIndex);
  
      videoPlayer.playbackRate = this.activeSlideIndex === this.activeSlideIndex ? 1.25 : 1.0;
  
    }
  }
  

    async nextMedia() {

    this.duration=null;
     this.currentIndex =   await this.slider.getActiveIndex();
    this.totalSlides =  await this.slider.length();
    if(this.formService.PermitSlidechange  ){
      this.formService.PermitSlidechange =false;

      console.log('currentIndex',this.currentIndex);
      console.log('totalSlides',this.totalSlides);
    if (this.currentIndex < this.totalSlides - 1) {
      this.slider.slideNext();
    } else {
      this.publication_template.nextPub();
      if(this.formService.publications.length === 1){
        console.log('there are no more posts');
        try {
          const result = await this.actualizacionservice.getAIPublications(null, false, null, false, null);
          const fetchedPublications = result || [];
          this.openComponentVideo(fetchedPublications);
        } catch (error) {
          console.error(error);
        }
      }else{
        console.log('there are already posts');
      }
      console.log('No more media slides available');
    }
          
  }

  }
  backMedia(){
    this.slider.slidePrev(); // Method to move to the next slide
  }
   async slideChanged() {
    this.formService.actual_publication=null;
    this.index=await this.slider.getActiveIndex();
    await this.publication_template.refreshActiveMediaPlayback();

      const publication = this.formService.publications[this.formService.publication_template_index];
    if (publication) {
      // Now you have the publication, you can work with it
      console.log('Current Publication:', publication);
  
    }
    
    //this.formService.changeMediaPeriodically=true;
  }
  ionSlideWillChange(){
    // Query all video and audio elements
this.formService.muteAllMedia();
  }
  //async slideChanged() {
    //const activeIndex = await this.slider.getActiveIndex();
   // const currentSlide = this.multimedia[activeIndex];
  
    // pause all videos
    //this.videoPlayers.toArray().forEach((player) => player.nativeElement.pause());
  
    // if current slide is a video, play it
    //if (currentSlide.type === 'Video') {
     // this.videoPlayers.toArray()[activeIndex].nativeElement.play();
   // }
  //}
  
  public isVideo(url:string) {
    Capacitor.convertFileSrc(url);
    return isVideo(url);
  }

  public isImage(url:string){
    Capacitor.convertFileSrc(url);
    return isImage(url);
  }

	openView2(index?: number) {
		this.modalController.create({
			component: MultimediaViewComponent,
      cssClass: 'detailsInModal',
			canDismiss: true, // canDismiss enables swipe-to-close (patch forces on ALL ModalController creates)
			componentProps: {
				multimedia: this.multimedia,
				index: index + 1,
				publication: this.publication,
				savePublication: this.savePublication,
				sharePublication: this.sharePublication,
			}
		}).then((modal)=>{
			modal.present();
		});
	}

  open_modal(pub) {
    if (pub.publication_type === 'lkfilm'){
      console.log('ES LKFILM!!', pub);
      let pubforlkfilm = {
        owner: pub.owner,
        container: {
          multimediaContainer: pub.multimediaContainer,
          title: pub.title,
          description: pub.description
        }
      };
      this.modalController
        .create({
          component: LkfilmViewBySlidesComponent,
          cssClass: 'detailsInModal',
          canDismiss: true, // (forced globally for swipe close on all modals)
          componentProps: {
            publication: pubforlkfilm,
          },
        })
        .then((modal) => {
          modal.present();
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  calculateSlidesPerView() {
		// Keep the actual media aligned with its full-width publication surface.
    this.window_width = '100';

  }
  onResize(event: Event) {
    if (this.landscapeStage) {
      this.updateLandscapeStageSize();
      return;
    }
    this.formService.mostrar=false;
this.calculateSlidesPerView();
    this.scheduleFooterOffsetUpdate();
    this.scheduleLandscapeFullscreenControlPosition();
  }
}
